import * as React from "react"

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar"
import { Link, useLocation } from "react-router-dom"
import { data } from "@/constants/sidebar"
import { useQueryParams } from "@/hooks/use-query-params"
import { PortalSidebarHeader } from "./portal-sidebar-header"
import { PortalReportsSidebarMenu } from "./portal-reports-sidebar-menu"
import { PortalSidebarFooter } from "./portal-sidebar-footer"
import { PortaAdminSidebarMenu } from "./portal-admin-sidebar-menu"
import { PortalConfigurationsSidebarMenu } from "./portal-configurations-sidebar-menu"
import { usePermissions } from "@/providers/permission-provider"
import { PortalMiddleSidebarMenu } from "./portal-sidebar-middle-menu"
import {
  handleToggleSidebar,
  isLinkActive,
} from "@/utils/sidebar"

export const PortalSidebar = () => {
  const { toggleSidebar, isMobile } = useSidebar()
  const { isSuperAdmin } = usePermissions()
  const location = useLocation()
  const pathname = location.pathname
  const queryParams = useQueryParams()

  const brokerId = queryParams.brokerId

  const getLinkHref = (
    brokerId: string | null | undefined,
    href: string
  ) => {
    if (!brokerId) return href
    return `${href}?brokerId=${brokerId}`
  }

  return (
    <Sidebar collapsible="icon">
      <PortalSidebarHeader />
      <SidebarContent>
        <SidebarGroup className="space-y-2">
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton
                asChild
                tooltip={data.firstSidebarLink.tooltip}
                isActive={isLinkActive(
                  data.firstSidebarLink.href,
                  data.firstSidebarLink.mainPath,
                  pathname
                )}
                onClick={() =>
                  handleToggleSidebar(
                    isMobile,
                    toggleSidebar
                  )
                }
              >
                <Link
                  to={getLinkHref(
                    brokerId,
                    data.firstSidebarLink.href
                  )}
                >
                  <data.firstSidebarLink.icon />
                  <span>{data.firstSidebarLink.label}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>

          <PortalReportsSidebarMenu />

          <PortalMiddleSidebarMenu />

          {isSuperAdmin && <PortaAdminSidebarMenu />}

          {isSuperAdmin && <PortalConfigurationsSidebarMenu />}
        </SidebarGroup>
      </SidebarContent>

      <PortalSidebarFooter />
      <SidebarRail />
    </Sidebar>
  )
}
